import { memo, type PropsWithChildren, type ReactNode } from "react";
import { GripVertical } from "lucide-react";
import type { CardColor } from "../../core/editor-types";

interface NodeFrameProps extends PropsWithChildren {
  className?: string;
  color?: CardColor;
  selected?: boolean;
  header?: ReactNode;
  bare?: boolean;
}

export const NodeFrame = memo(function NodeFrame({
  children,
  className = "",
  color = "paper",
  selected,
  header,
  bare,
}: NodeFrameProps) {
  return (
    <article
      className={`node-frame node-color-${color} ${selected ? "is-selected" : ""} ${bare ? "is-bare" : ""} ${className}`}
    >
      {header ? (
        <header className="node-frame__header drag-handle">
          <GripVertical aria-hidden="true" size={13} className="node-frame__grip" />
          {header}
        </header>
      ) : null}
      <div className="node-frame__content">{children}</div>
    </article>
  );
});

